import * as React from 'react';

import FileVector16 from './FileVector16';

export const fileVector16 = () => <FileVector16 />;

export default {
    title: 'Icon|Fill|FileVector16',
    component: FileVector16,
    parameters: {
        notes: "`import FileVector16 from 'box-ui-elements/es/icon/fill/FileVector16';`",
    },
};
